<template>
  <v-app-bar
    class="header"
    hide-on-scroll
    elevate-on-scroll
    scroll-threshold="250"
    height="160px"
    app
  >
    <v-sheet width="100%">
      <v-sheet class="d-flex align-center mt-10" color="#fbfbfb" height="160px">
        <v-container class="py-5">
          <v-sheet
            width="100%"
            height="100%"
            color="transparent"
            class="d-flex justify-space-around align-center"
          >
            <router-link to="/">
              <img
                v-if="informations.img"
                class="d-block"
                :src="files + informations.img"
                :alt="informations.name"
                height="120px"
              />
            </router-link>

            <SearchWidget />
          </v-sheet>
        </v-container>
      </v-sheet>

      <v-sheet color="secondary" width="100%">
        <v-container class="py-0">
          <div class="d-flex justify-center align-center">
            <div>
              <div
                v-for="({ text, to, dropdown }, keyMenu) in menu"
                :key="keyMenu"
                class="d-inline-flex mx-1 mx-lg-2"
              >
                <v-btn
                  v-if="!dropdown"
                  class="
                    text-h4 text-md-h3 text-none
                    font-weight-medium
                    px-2 px-lg-3
                    nav-link
                  "
                  :to="to"
                  active-class="nav-link-active"
                  height="45px"
                  depressed
                  tile
                  text
                >
                  {{ text }}
                </v-btn>

                <v-menu v-else offset-y tile>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      class="
                        text-h4 text-md-h3 text-none
                        font-weight-medium
                        px-2 px-lg-3
                        nav-link
                      "
                      active-class="nav-link-active"
                      height="45px"
                      depressed
                      tile
                      text
                    >
                      {{ text }}
                      <v-icon class="ml-3" size="12"> fa-caret-down </v-icon>
                    </v-btn>
                  </template>

                  <div class="secondary darken-1 d-flex">
                    <v-list
                      class="secondary darken-1 py-0"
                      width="250px"
                      tile
                      v-for="dropdownLength in Math.ceil(
                        dropdown.length / menuItemsPerPage
                      )"
                      :key="dropdownLength"
                    >
                      <v-list-item
                        v-for="(item, keyDropdown) in dropdown.slice(
                          (dropdownLength - 1) * menuItemsPerPage,
                          dropdownLength * menuItemsPerPage
                        )"
                        exact
                        class="nav-link"
                        :key="keyDropdown"
                        :to="item.to"
                      >
                        <v-list-item-title class="white--text">
                          <span class="font-secondary">
                            {{ item.text }}
                          </span>
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </div>
                </v-menu>
              </div>
            </div>
          </div>
        </v-container>
      </v-sheet>
    </v-sheet>
  </v-app-bar>
</template>

<script>
import SearchWidget from "../../widgets/SearchWidget.vue";

export default {
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    menuItemsPerPage: 10,
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
  },
  components: {
    SearchWidget,
  },
};
</script>

<style lang="scss" scoped>
.header::v-deep {
  .v-toolbar__content {
    padding: 0;
  }
}

.nav-link::v-deep {
  background-color: transparent;
  color: white !important;
  transition: all 0.1s linear;

  &.nav-link-active {
    background-color: var(--v-primary-lighten3);
    color: var(--v-secondary-darken1) !important;
  }

  .v-list-item__title {
    word-break: break-word;
    white-space: initial;
  }
}
</style>
